import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class TravelCategoryService {
  static gettravelCategoryList(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.gettravelCategory}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.gettravelCategory}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addtravelCategory(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addtravelCategory}`;
    return axiosInstance
        .post(api,item)
        
}
static edittravelCategory(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.edittravelCategory}`;
    return axiosInstance
        .put(api,item)
        
}
static deletetravelCategory(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletetravelCategory}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deletetravelCategory}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default TravelCategoryService;